// src/components/Footer.tsx
import React from 'react';
import {
  Box,
  Container,
  Stack,
  Typography,
  IconButton,
} from '@mui/material';
import {
  Facebook,
  Twitter,
  LinkedIn,
} from '@mui/icons-material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.dark',
        color: 'white',
        py: 4,
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={3}
        >
          {/* Logo and Institution Name */}
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              component="img"
              src="/images/Logo2.png"
              alt="Logo"
              sx={{
                width: 80,
                height: 80,
                borderRadius: 1,
                p: 0.5,
              }}
            />
            <Box>
              <Typography variant="subtitle2" fontWeight={700}>
                INSTITUCIÓN EDUCATIVA
              </Typography>
              <Typography variant="body2">
                JOSÉ EUSEBIO CARO
              </Typography>
            </Box>
          </Stack>

          {/* Social Media */}
          <Box>
            <Typography
              variant="subtitle2"
              fontWeight={600}
              sx={{ mb: 1, textAlign: { xs: 'center', md: 'right' } }}
            >
              Social Profiles
            </Typography>
            <Stack direction="row" spacing={1} justifyContent={{ xs: 'center', md: 'flex-end' }}>
              <IconButton
                sx={{
                  backgroundColor: 'white',
                  color: 'primary.dark',
                  '&:hover': { backgroundColor: '#f0f0f0' },
                }}
                size="small"
              >
                <Facebook fontSize="small" />
              </IconButton>
              <IconButton
                sx={{
                  backgroundColor: 'white',
                  color: 'primary.dark',
                  '&:hover': { backgroundColor: '#f0f0f0' },
                }}
                size="small"
              >
                <Twitter fontSize="small" />
              </IconButton>
              <IconButton
                sx={{
                  backgroundColor: 'white',
                  color: 'primary.dark',
                  '&:hover': { backgroundColor: '#f0f0f0' },
                }}
                size="small"
              >
                <LinkedIn fontSize="small" />
              </IconButton>
            </Stack>
          </Box>
        </Stack>

        {/* Divider */}
        <Box
          sx={{
            borderTop: '1px solid rgba(255,255,255,0.1)',
            mt: 3,
            pt: 3,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              textAlign: 'center',
              color: 'rgba(255,255,255,0.7)',
            }}
          >
            © 2025 JECARO. Todos los derechos reservados.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;